import "./external.css";

import React from "react";
import { Helmet } from "react-helmet";

import { ENTRY_POINT } from "../../utils/stateTypes";
import { getEntryPoint } from "../../utils/entryStorage";
import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import GreenBlockSection from "../sections/GreenBlockSection";
import BlockHeading from "../sections/BlockHeading";
import CoverFlowGallery from "../sections/CoverFlowGallery";
import Contact from "../sections/Contact";

const GALLERY_IMAGES_1 = {
  [ENTRY_POINT.DEFAULT]: [
    { src: "/images/block-gallery-1/Varene-Burton-(28).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-14.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-9.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Varene-Burton-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(66).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-10.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(64).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(60).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Floral-New-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
  ],
  [ENTRY_POINT.CORPORATE]: [
    { src: "/images/block-gallery-1/Varene-Burton-(28).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-14.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-9.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Varene-Burton-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(66).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-10.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(64).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(60).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Floral-New-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
  ],
  [ENTRY_POINT.BLACK_DIAMOND]: [
    { src: "/images/block-gallery-1/Varene-Burton-(28).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-14.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-9.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Varene-Burton-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(66).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-10.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(64).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(60).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Floral-New-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
  ],
  [ENTRY_POINT.LOVE_IS_LOVE]: [
    { src: "/images/block-gallery-1/Varene-Burton-(28).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-14.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-9.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Varene-Burton-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(66).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-Reception-Feb-2026-10.jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(64).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/SG-img-(60).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
    { src: "/images/block-gallery-1/Floral-New-(9).jpg", alt: "A beautiful wedding setup created by The Shepstone team" },
  ],
};

const HEADING_1 = {
  [ENTRY_POINT.DEFAULT]: [
    "Turn any venue into something magical",
  ],
  [ENTRY_POINT.CORPORATE]: [
    "Turn any venue into something magical",
  ],
  [ENTRY_POINT.BLACK_DIAMOND]: [
    "Turn any venue into something magical",
  ],
  [ENTRY_POINT.LOVE_IS_LOVE]: [
    "Turn any venue into something magical",
  ],
};

const External = () => {
  return (
    <div>
      <Helmet>
        <title>The Shepstone Experience | Weddings, Special Occasions & Corporate Functions</title>
        <meta
          name={"description"}
          content={"Bring the Shepstone magic to your own venue, where special occasions are nurtured into unforgettable moments to be cherished forever."}
        ></meta>
      </Helmet>
    
      <Header
        bgImg={"/images/Box-Hat-Banner.jpg"}
        headText={"BRING THE SHEPSTONE EXPERIENCE TO YOUR OWN LOCATION"}
      />

      <LineSeparator noLine />
      <LineSeparator noLine />

      <GreenBlockSection
        headText={"Now at any venue of your choice"}
        subHeadText={"The Shepstone Experience"}
      >
        <div className={"three-columns"}>
          <p className={"venue-intro-text"}>
            At The Shepstone Experience, we have long been celebrated for transforming our historic estate into a world of romance, beauty, and unforgettable celebration. Known as one of Johannesburg’s most enchanting wedding venues, our team has perfected the art of seamless planning, exquisite décor, and breathtaking floral design — all delivered with the warmth and personal care that define The Shepstone Experience.
          </p>
          <p className={"venue-intro-text"}>
            Now, we are proud to extend that same signature elegance beyond our gates.
          </p>
          <p className={"venue-intro-text"}>
            Whether you envision your special day at another wedding venue, a luxury hotel, a private estate, or even in the intimacy of your own home, our dedicated team will bring the full Shepstone Experience to you.
          </p>
          <p className={"venue-intro-text"}>
            From concept development and meticulous planning to bespoke décor styling, floral artistry, and on-the-day coordination, we curate every detail with precision and creativity.
          </p>
          <p className={"venue-intro-text"}>
            We work closely with each client to interpret their vision, elevate their ideas, and craft a cohesive aesthetic that feels both personal and extraordinary. The result is a flawlessly executed celebration — infused with our timeless style, thoughtful touches, and commitment to excellence — no matter the setting.
          </p>
          <p className={"venue-intro-text"}>
            Wherever you choose to say “I do,” let us transform your chosen space into something truly magical.
          </p>
          <p className={"venue-intro-text"}>
            The Shepstone Experience: anywhere.
          </p>
        </div>
      </GreenBlockSection>
      
      <LineSeparator noLine />
      <LineSeparator noLine />
      <LineSeparator />
      <BlockHeading
        headText={HEADING_1[getEntryPoint()]}
        noBorder
      />

      <CoverFlowGallery
        images={GALLERY_IMAGES_1[getEntryPoint()]}
        noOvButton
      />

      <LineSeparator />
      <Contact headText={"Schedule a meeting with us"} />
    </div>
  );
};

export default External;